import { Component, EventEmitter, Injectable, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { formatDate } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { IDropdownSettings, MultiSelectComponent } from 'ng-multiselect-dropdown';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { untilDestroyed } from 'src/app/core/until-destroyed';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from 'src/app/services/app-insights.service';
import { StateService } from 'src/app/services/state.service';

export const PICK_FORMATS = {
  parse: {
    dateInput: 'input',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'input',
    monthYearA11yLabel: 'YYYY',
  },
};
@Injectable()
class PickDateAdapter extends NativeDateAdapter {
  format(date: Date): string {
    return formatDate(date, 'dd-MM-yyyy', this.locale);
  }
}

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: PickDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
    ],
    standalone: false
})
export class SearchComponent implements OnInit, OnDestroy {

  advSearch: UntypedFormGroup;
  // showAdvanced = false;
  dropdownSettings: IDropdownSettings;
  allDepos = [];
  selectedDepos = [];
  routeList = [];
  depotList = [];
  statusList = [];
  selectedUser;
  maxDate = new Date();
  filteredUsers: Observable<any>;
  pageNumber=1;

  @ViewChildren('routelistElement') routelistElement: QueryList<MultiSelectComponent>;
  @ViewChildren('depotlistElement') depotlistElement: QueryList<MultiSelectComponent>;
  @Output() showAdvancedEvent: EventEmitter<any> = new EventEmitter();
  @Output() filterGrid: EventEmitter<any> = new EventEmitter();
  @Input() showAdvanced: any;
  @Input() searchFilter: any;
  @Input() pageSize: number;
  isLoading: boolean;

  constructor(private formBuilder: UntypedFormBuilder, private ds: DataService,
    private appInsightsService: AppInsightsService, private stateService: StateService) {

    this.advSearch = this.formBuilder.group({
      route: [''],
      depot: [''],
      submittedBy: [''],
      status: [''],
      submittedfrom: [''],
      submittedTo: [''],
      plansExecuted: [''],
      assetId: [''],
      handoverOnly: [''],

    });

  }




  ngOnInit(): void {

    this.checkRoleAndSubmitEvent();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      enableCheckAll: false,
      // selectAllText: 'Select All',
      // unSelectAllText: 'UnSelect All',
      // itemsShowLimit: 3,
      // allowSearchFilter: true
    };

    this.statusList = [
      {
        key: 1,
        value: 'SUBMITTED'
      },
      {
        key: 2,
        value: 'APPROVED'
      },
      {
        key: 3,
        value: 'IN REVIEW'
      },
      {
        key: 4,
        value: 'SENT TO RETEST'
      },
      {
        key: 8,
        value: 'HANDOVER PENDING'
      },
    ];

    this.ds.getService(environment.BASEURL + '/GetOrgData')
      .subscribe(data => {
        if (data && data.routes) {
          this.routeList = [];
          this.allDepos = [];
          data.routes.forEach((route, index) => {
            this.routeList.push({ key: index, value: route.name });
            route.imdms.forEach(imdms => {
              imdms.tmEs.forEach(tmEs => {
                tmEs.sectionManager.forEach(sm => {

                  const depot = {
                    id: sm.id,
                    name: sm.name
                  };
                  this.allDepos.push({ name: route.name, depot });
                });
              });
            });
          });
          if (this.routelistElement.first) {
            this.routelistElement.first.data = this.routeList;
          }
          if (this.depotlistElement.first) {
            this.depotlistElement.first.data = [{
              key: 0,
              value: ''
            }];
          }

          if (this.searchFilter) {
            this.advSearch.setValue(this.searchFilter);
            if (this.searchFilter.route) {
              this.selectedDepos = this.searchFilter.route;
              this.setDepos();
            }
          }
        }
      });

    this.advSearch.get('submittedBy').valueChanges
      .subscribe((value) => (value && value.length >= 3) ? this.getUsers(value) : (this.filteredUsers = of([])));



  }

  ngOnDestroy() {
    console.log('destroyed');
  }
  get f() {
    return this.advSearch.controls;
  }

  submitForm() {

    let query = '?';
    let selectedDepos;
    if (this.advSearch.value.depot && this.advSearch.value.depot.length > 0) {
      for (var i = 0; i < this.advSearch.value.depot.length; i ++) {
        this.appInsightsService.logPageView('Search - ' + this.advSearch.value.depot[i].value);
      }
      selectedDepos = this.advSearch.value.depot.map(x => x.key).join(',');
      query += `depot=${selectedDepos}`;
    } else {
      if (this.advSearch.value.route && this.advSearch.value.route.length > 0) {
        const selectedRoutes = this.advSearch.value.route.map(x => x.value);
        selectedDepos = this.allDepos.filter(x => selectedRoutes.includes(x.name)).map(x => x.depot).map(x => x.id).join(',');
        query += `depot=${selectedDepos}`;
      }
    }
    if (this.selectedUser) {
      query += `&submittedBy=${this.selectedUser.userId}`;
    }
    if (this.advSearch.value.plansExecuted) {
      query += `&plansExecuted=${this.advSearch.value.plansExecuted}`;
    }
    if (this.advSearch.value.assetId) {
      query += `&assetId=${this.advSearch.value.assetId}`;
    }
    let selectedStatus;
    if (this.advSearch.value.status && this.advSearch.value.status.length > 0) {
      selectedStatus = this.advSearch.value.status.map(x => x.key);
      query += `&status=${selectedStatus}`;
    }
    const fromDate = this.advSearch.value.submittedfrom ? this.advSearch.value.submittedfrom.getTime() : this.advSearch.value.submittedfrom;
    if (fromDate) {
      query += `&submittedFrom=${fromDate}`;
    }
    const toDate = this.advSearch.value.submittedTo ? this.advSearch.value.submittedTo.getTime() : this.advSearch.value.submittedTo;
    if (toDate) {
      query += `&submittedTo=${toDate}`;
    }
    const handoverOnly = this.advSearch.value.handoverOnly ? this.advSearch.value.handoverOnly : false;
    query += `&handoverOnly=${handoverOnly}`;
    query += `&pagenumber=${this.pageNumber}`;
    query += `&pageIndex=${this.pageSize}`;

    this.ds.getService(`${environment.BASEURL}${environment.FILTERTESTSLIPS}${query}`)
      .subscribe(res => {
        this.filterGrid.emit({ result: res, criteria: this.advSearch.value, query });
      });

  }

  applyAdvSerarch(pageNumber){
    this.pageNumber = pageNumber;
    this.submitForm();
  }

  getUsers(value: string) {
      this.ds.getService(environment.BASEURL +   environment.GET_SYSUSER_BY_TEXT.replace(
          '{keyWord}',
          value
        ))
      .pipe(untilDestroyed(this),
        tap((a) => { this.isLoading = true; }
        ))
      .subscribe((data: any) => {
        let decriptdata = this.ds.decrypt(
          environment.ENCRYPTKEY_DATA,
          data?.users
        );
        let parseData = JSON.parse(decriptdata);
        this.isLoading = false;
        this.filteredUsers = of(
          parseData.length > 0
            ? parseData.filter((e) => e.displayName)
            : ['no data found']
        );
      });
  }

  public displayProperty(value) {
    if (value) {
      return value.displayName;
    }
  }
  clearUserField() {
    this.selectedUser = null;
  }

  getuserData(event) {
    this.selectedUser = event.option.value;
  }


  onRouteItemSelect(event) {
    this.modifyRouteList(1, event);
  }
  onRouteSelectAll(event) {
    this.modifyRouteList(1, event);
  }

  onRouteItemDeselect(event) {
    this.modifyRouteList(2, event);
  }

  onItemSelect(event) {
    // console.log(event);
  }
  onSelectAll(event) {
    // console.log(event);
  }

  modifyRouteList(option, event) {
    if (option === 1) {
      this.selectedDepos.push(event);
    } else {
      this.selectedDepos.splice(this.selectedDepos.findIndex(x => x.key === event.key), 1);
    }
    this.setDepos();
  }

  setDepos() {
    this.depotList = [];
    if (this.selectedDepos && this.selectedDepos.length > 0) {
      this.selectedDepos.forEach(depo => {
        const selectedDepos = this.allDepos.filter(x => x.name === depo.value);
        if (selectedDepos && selectedDepos.length > 0) {
          selectedDepos.forEach(d => {
            this.depotList.push({ key: d.depot.id, value: d.depot.name });
          });
        }
      });
    }
    this.depotlistElement.first.data = this.depotList;
  }

  showAdvancedSearch() {
    this.showAdvanced = true;
    this.showAdvancedEvent.emit({ visible: true, forceRefesh: false });
    this.ngOnInit();
  }
  hideAdvancedSearch() {
    this.advSearch.reset();
    this.selectedDepos = [];
    this.searchFilter = null;
    this.showAdvancedEvent.emit({ visible: false, forceRefesh: false });
    this.showAdvanced = false;
  }
  reset() {
    this.advSearch.reset();
    this.showAdvanced = true;
    this.showAdvancedEvent.emit({ visible: true, forceRefesh: true });
  }

  checkRoleAndSubmitEvent() {
    let rolesList = [...new Set(this.stateService.userRoles)];
    let depoList = [...new Set(this.stateService.allDepos)];
    if (rolesList.includes("Admin")){
      this.appInsightsService.logPageView('Admin');
    } else if (rolesList.includes("Submit & View Test Slips") && rolesList.includes("Review Test Slips")) {
      for (var i = 0; i < depoList.length; i ++) {
        this.appInsightsService.logPageView('Submit & View Test Slips - ' + depoList[i]);
      }
    } else if (rolesList.includes("Review Test Slips")) {
      for (var i = 0; i < depoList.length; i ++) {
        this.appInsightsService.logPageView('Review Test Slips - ' + depoList[i]);
      }
    }
  }

}
